import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OptionsProvider, useOptionsContext } from "~/Contexts/OptionsContext";
import { react2Angular } from "~/Core/React2Angular";
import { initializeTelemetry } from "~/Services/Telemetry";

const queryClient = new QueryClient();

// we need the optionsProvider to load right away so it can setup telemetry
// but we also need to be signed in
export const TelemetryLoader = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <OptionsProvider>
                <InitializeTelemetry />
            </OptionsProvider>
        </QueryClientProvider>
    );
};

const InitializeTelemetry = () => {
    let options = useOptionsContext();
    initializeTelemetry(options);

    return null;
};

angular.module("insite-admin").component("telemetryLoader", react2Angular(TelemetryLoader));
